import { useListView } from '../../core/ListViewProvider';

const ProjectSelectionHeader = ({tableProps}) => {
  const projectsIds = tableProps?.data?.filter((ele: any) => ele?.eNDAprotected === '0')?.map((ele: any) => ele?.id) || [];
  const {isAllSelected, selected, setSelected} = useListView();
  
  return (
    <th {...tableProps.column.getHeaderProps()} className='w-10px pe-2'>
      <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
        <input
          className='form-check-input cursor-pointer'
          style={{
            cursor: projectsIds?.length > 0 ? 'pointer' : 'not-allowed' 
          }}
          type='checkbox'
          data-kt-check={isAllSelected}
          data-kt-check-target='#kt_table_users .form-check-input'
          checked={isAllSelected}
          onChange={() => {
            if (selected?.length > 0) {
              setSelected([])
            } else {
              setSelected(projectsIds)
            }
          }}
        />
      </div>
    </th>
  )
}

export default ProjectSelectionHeader;
